import { render } from "./TabBar.vue?vue&type=template&id=ab947e9a&scoped=true"
import script from "./TabBar.vue?vue&type=script&lang=js"
export * from "./TabBar.vue?vue&type=script&lang=js"

import "./TabBar.vue?vue&type=style&index=0&id=ab947e9a&lang=less&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab947e9a"]])

export default __exports__